import * as React from 'react';
import clsx from 'clsx';
import { ShareHeader } from './ShareHeader';
import copyIcon from '@/assets/images/svg/share_copy_icon.svg';

interface LinkShareProps {
  link: string;
  onCopy: () => void;
}

export const LinkShare: React.FC<LinkShareProps> = ({ link, onCopy }) => (
  <div className='flex w-full flex-col gap-6'>
    <ShareHeader title='Share This Echo' />

    <div className='flex flex-col gap-1'>
      {/* Subtitle */}
      <p
        className={clsx(
          // Inter V, Regular, 14px, 24px LH, #323232 (gray-600)
          'font-sans text-14 font-normal leading-24 tracking-normal text-gray-600'
        )}
      >
        Share Private Link
      </p>

      {/* Input Container */}
      <div
        className={clsx(
          'flex items-center justify-between',
          'h-[50px] w-full px-4', // Height inferred from standard input, padding added
          // Border: 1px solid #E7E0FF (purple-120), Radius 10px (nav-item)
          'rounded-nav-item border border-purple-120 bg-white'
        )}
      >
        <span
          className={clsx(
            // Plus Jakarta Sans, Regular, 14px, 160% LH, -2% LS, #1A1036
            'truncate font-jakarta text-14 font-normal leading-160 tracking-neg-2 text-brand-800'
          )}
        >
          {link}
        </span>

        <button
          onClick={onCopy}
          className='ml-2 transition-opacity hover:opacity-70'
          aria-label='Copy link'
        >
          <img src={copyIcon} alt='Copy' className='size-5' />
        </button>
      </div>
    </div>
  </div>
);
